// In-app browser / WebView detection from the user agent. Named apps first, generic last.
const IN_APP_BROWSER_PATTERNS = [
    {name: 'facebook', pattern: /FBAN|FBAV|FB_IAB|FB4A|FBIOS/i},
    {name: 'instagram', pattern: /Instagram/i},
    {name: 'tiktok', pattern: /TikTok|musical_ly|Bytedance/i},
    {name: 'snapchat', pattern: /Snapchat/i},
    {name: 'twitter', pattern: /Twitter/i},
    {name: 'linkedin', pattern: /LinkedInApp/i},
    {name: 'pinterest', pattern: /Pinterest/i},
    {name: 'line', pattern: /\bLine\//i},
    // Generic fallbacks
    {name: 'android_webview', pattern: /Android.*(; wv\)|Version\/\d[\d.]*.*Chrome)/i},
    {name: 'ios_webview', pattern: /^(?=.*(iPhone|iPad|iPod))(?!.*(Safari|CriOS|FxiOS)).*$/i}
];

export const detectInAppBrowser = (ua = window?.navigator?.userAgent || '') => {
    const match = IN_APP_BROWSER_PATTERNS.find(({pattern}) => pattern.test(ua));

    return {
        is_in_app_browser: match ? 1 : 0,
        in_app_browser: match ? match.name : null
    };
};
